/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc
 */
import * as References from './ContentStagingPagesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getDraftPages
 */
export const GET_DRAFT_PAGES_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getDraftPages';
export const GET_DRAFT_PAGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DRAFT_PAGES_QUERY_FIELD_NAME,
  args: ['domainName', 'nameContains', 'pageType', 'orderBy', 'orderByAsc', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDraftPagesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getProofPages
 */
export const GET_PROOF_PAGES_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getProofPages';
export const GET_PROOF_PAGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROOF_PAGES_QUERY_FIELD_NAME,
  args: ['domainName', 'nameContains', 'pageType', 'orderBy', 'orderByAsc', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getProofPagesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getUnstagedPages
 */
export const GET_UNSTAGED_PAGES_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getUnstagedPages';
export const GET_UNSTAGED_PAGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_UNSTAGED_PAGES_QUERY_FIELD_NAME,
  args: ['domainName', 'nameContains', 'pageType', 'orderBy', 'orderByAsc', 'offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getUnstagedPagesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getPageCounts
 */
export const GET_PAGE_COUNTS_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getPageCounts';
export const GET_PAGE_COUNTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAGE_COUNTS_QUERY_FIELD_NAME,
  args: ['domainName', 'nameContains'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getPageCountsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getStagedPage
 */
export const GET_STAGED_PAGE_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getStagedPage';
export const GET_STAGED_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STAGED_PAGE_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getStagedPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#getStagedPageContent
 */
export const GET_STAGED_PAGE_CONTENT_QUERY_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_getStagedPageContent';
export const GET_STAGED_PAGE_CONTENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STAGED_PAGE_CONTENT_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getStagedPageContentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#stageExistingPage
 */
export const STAGE_EXISTING_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_stageExistingPage';
export const STAGE_EXISTING_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: STAGE_EXISTING_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId', 'domainName', 'name', 'mode'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.stageExistingPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#stageNewPage
 */
export const STAGE_NEW_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_stageNewPage';
export const STAGE_NEW_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: STAGE_NEW_PAGE_MUTATION_FIELD_NAME,
  args: ['name', 'domainName', 'subcategory'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.stageNewPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#cloneStagedPage
 */
export const CLONE_STAGED_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_cloneStagedPage';
export const CLONE_STAGED_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLONE_STAGED_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId', 'name', 'domainName'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.cloneStagedPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#autoSaveStagedPage
 */
export const AUTO_SAVE_STAGED_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_autoSaveStagedPage';
export const AUTO_SAVE_STAGED_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: AUTO_SAVE_STAGED_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId', 'fieldChanges'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.autoSaveStagedPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#manualSaveStagedPage
 */
export const MANUAL_SAVE_STAGED_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_manualSaveStagedPage';
export const MANUAL_SAVE_STAGED_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MANUAL_SAVE_STAGED_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId', 'fieldChanges'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.manualSaveStagedPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#proofPage
 */
export const PROOF_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_proofPage';
export const PROOF_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PROOF_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.proofPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#unproofPage
 */
export const UNPROOF_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_unproofPage';
export const UNPROOF_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNPROOF_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.unproofPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingPagesRpc#deleteStagedPage
 */
export const DELETE_STAGED_PAGE_MUTATION_FIELD_NAME = 'com_hubspot_contentstaging_rpc_ContentStagingPagesRpc_deleteStagedPage';
export const DELETE_STAGED_PAGE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_STAGED_PAGE_MUTATION_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.deleteStagedPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});